module.exports = __webpack_public_path__ + "static/media/home_icon.44da4e2d.svg";